import React, { useState, useEffect } from 'react';
import { DropdownToggle, DropdownMenu, Dropdown, DropdownItem } from 'reactstrap';
import { connect } from 'react-redux';
import { get, isEmpty, size, take, reject } from 'lodash';
import * as MeActions from '../../../../../actions/MeActions.js';
import { MDTApp } from '../../../../../actions/bootAction.js';
import { successToast } from '../../../../atoms/mdt-snackbar/index.js';
import { sendEventTrackingData } from '../../../../../helpers/commonUtils.js';
import './toolbarHospital.css';

const ToolbarHospital = (props) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    // const [dropDownName] = useState(
    //   !isEmpty(this.props.prefCustomer) &&
    //     this.props.prefCustomer.name.substring(0, 52)
    // );
    // const [dropDownAddress] = useState(
    //   !isEmpty(this.props.prefCustomer) &&
    //     this.props.prefCustomer.soldTo.address.line1
    // );
    const { prefCustomer, t } = props;
    const showViewAllCustomer = 6;

    useEffect(() => {
        const customerSelect = sessionStorage.getItem('showCustomerSelectNotification');
        if (customerSelect === 'true') {
            successToast(props.t('hospital.customerChanged'));
            sessionStorage.removeItem('showCustomerSelectNotification');
        }
    }, [props]);

    useEffect(() => {
        if (dropdownOpen) {
            const eventParamObj = {
                eventCategory: 'globalHeader',
                eventAction: 'customerChange',
                eventLabel: props.pageName,
                processLabels: false,
            };
            sendEventTrackingData(eventParamObj);
        }
    }, [dropdownOpen, props]);

    const toggle = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const changeValue = (hospital) => {
        const buId = window.MDTSetting.buid;
        const refererAppId = window.MDTSetting.appid;
        const refererAppUrl =
            window.MDTSetting.links.home || window.location.origin + window.location.pathname;
        const customerId = hospital.id;
        props.selectCustomer(customerId, refererAppId, buId, refererAppUrl);
        sessionStorage.setItem('showCustomerSelectNotification', 'true');

        const eventParamObj = {
            eventCategory: 'globalHeader',
            eventAction: 'customerSelected',
            eventLabel: customerId,
            processLabels: false,
        };
        sendEventTrackingData(eventParamObj);
    };

    const viewAllCustomer = (customerId) => {
        const url = window.MDTSetting.links['portal-select-customer'];

        MDTApp.goto(url, {
            refererAppId: window.MDTSetting.appid,
            refererAppUrl: window.location.origin + (window.MDTSetting.links.home || ''),
            customerId,
        });
    };

    return (
        <div className={props.className}>
            {
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                    {size(props.customer) >= 1 && !isEmpty(props.customer) && (
                        <DropdownToggle caret>
                            <div className='selected-customer'>
                                <div className=' customer-name body3 p-active'>
                                    {props.prefCustomer.name}
                                </div>
                                <div className='customer-name sold-to-addr body3 m-emphasis'>
                                    {get(prefCustomer, 'soldTo.address.line1', '')}
                                </div>
                            </div>
                        </DropdownToggle>
                    )}
                    {size(props.customer) === 0 && size(props.prefCustomer) > 1 && (
                        <DropdownToggle className='no-hospital-list'>
                            <div className='selected-customer'>
                                <div className=' customer-name body3 p-active'>
                                    {props.prefCustomer.name}
                                </div>
                                <div className='customer-name sold-to-addr body3 m-emphasis'>
                                    {get(prefCustomer, 'soldTo.address.line1', '')}
                                </div>
                            </div>
                        </DropdownToggle>
                    )}
                    {size(props.customer) >= 1 && (
                        <DropdownMenu className='elevation-3'>
                            {!isEmpty(props.customer) &&
                                take(props.customer, 6).map((hospital, indexHos) => (
                                    <div key={`hospital-${indexHos}`}>
                                        <DropdownItem divider />
                                        <DropdownItem
                                            onClick={() => {
                                                changeValue(hospital);
                                            }}
                                        >
                                            <span className='body3 p-active'>
                                                {hospital.name.substring(0, 52)}
                                            </span>
                                            <br />
                                            <span className='body3 m-emphasis d-inline'>
                                                {get(hospital, 'soldTo.address.streetName', '')}
                                            </span>
                                            {/* <span className="body3 m-emphasis d-inline">,&nbsp;{hospital.soldTo.address.town}</span>
                      <span className="body3 m-emphasis d-inline">,&nbsp;{hospital.soldTo.address.postalCode}</span> */}
                                        </DropdownItem>
                                        {indexHos === showViewAllCustomer - 1 && (
                                            <DropdownItem divider />
                                        )}
                                    </div>
                                ))}
                            {size(props.customer) > showViewAllCustomer && (
                                <DropdownItem
                                    onClick={() => {
                                        viewAllCustomer(props.prefCustomer.id);
                                    }}
                                >
                                    <span className='view-all-customer'>
                                        {t('viewAllCustomers')}{' '}
                                        <span className='icon-arrow_right cus-icon' />
                                    </span>{' '}
                                </DropdownItem>
                            )}
                        </DropdownMenu>
                    )}
                </Dropdown>
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    let customerList = {};
    let prefCustomer = {};

    try {
        if (!isEmpty(state.meDetails.manageCustomerList.customers)) {
            customerList = state.meDetails.manageCustomerList.customers;
            prefCustomer = state.meDetails.defaultCustomer;
            customerList = reject(customerList, function (c) {
                return c.id === prefCustomer.id;
            });
        }
    } catch (err) {
        customerList = {};
    }

    return {
        customer: customerList,
        prefCustomer,
        pageName: state.page,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectCustomer: (customerId, refererAppId, buId, refererAppUrl) =>
            dispatch(MeActions.setPreferredCustomer(customerId, refererAppId, buId, refererAppUrl)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarHospital);
